import { testimonialPageLgTestimonials } from "../../../data/largeTestimonials";
import { glucoGenTestimonialTestimonials } from "../../../data/testimonials";
import TestimonialsMessage from "../../common/testimonial-message";
import TestimonialLargeGallery from "./testimonial-large-gallery";


const TestimonialsTestimonial = () => (
    <section id="testimonials" className="gg-bg-solid-green-light">
        <div className="container-fluid py-3">
            <div className="row justify-content-center align-items-center">
                <div className="col-11">
                    <div className="row justify-content-center align-items-center pb-3">
                        <div className="col-md-10 text-center">
                            <h2 className="fw-bold mb-0">They Took the First Step</h2>
                            <h3 className="">Here’s What Happened Next</h3>
                        </div>
                    </div>
                    <TestimonialLargeGallery
                        testimonials={testimonialPageLgTestimonials}
                      />
                    <TestimonialsMessage
                        testimonials={glucoGenTestimonialTestimonials} />
                </div>
            </div>
        </div>
    </section>
)

export default TestimonialsTestimonial;